import AssetViewModel from "@/domain/asset/AssetViewModel";
import ClientBase from "../ClientBase";

class AssetClient extends ClientBase {
    
    async getAssetsByOrganizationId(organizationId) {
        const data = await this.get(`api/v1/assets/organizations/${organizationId}`);
        return data?.map(asset => new AssetViewModel(asset)) ?? [];
    }

    async getAssetById(organizationId, assetId){
        const data = await this.get(`api/v1/assets/${organizationId}/${assetId}`);
        return data ? new AssetViewModel(data) : null;
    }

    async createAssetAsync(newAssetRequest){
        const data = await this.post('api/v1/assets', newAssetRequest);
        return data ? new AssetViewModel(data) : null;
    }

    async getAssetHistory(assetId) {
        const data = await this.get(`api/v1/assethistory/assets/${assetId}`);
        return data ?? [];
    }

    async updateAsset(updateRequest) {
        const data = await this.put(`api/v1/assets/${updateRequest.organizationId}/${updateRequest.assetId}`, updateRequest);
        return data ? new AssetViewModel(data) : null;
    }

    async updateAssetProfileImage(request) {
        const data = await this.put(`api/v1/assets/${request.organizationId}/${request.assetId}/image`, request);
        return data ? new AssetViewModel(data) : null;
    }

    async deleteAsset(organizationId, assetId, softDelete = true) {
        return await this.delete(`api/v1/assets/${organizationId}/${assetId}`, { softDelete });
    }
}

export default new AssetClient();